module.exports = __webpack_public_path__ + "img/about-us-bg.fb1e4ae9.png";